import { Store } from "@tanstack/react-store";
import { fulfilmentSearchFiltersDefaultValues } from "./fulfilmentSearchFiltersDefaultValues";
import { type FulfilmentSearchFilters } from "./fulfilmentSearchFiltersStoreSlice";
import { sessionDefaultValues } from "./sessionDefaultValues";
import { type SessionStoreSlice } from "./sessionStoreSlice";

export interface TaxManagerAppStoreSlice<T> {
    resetValues: () => void;
    updateValues: (newValues: Partial<T>) => void;
}

export interface TaxManagerAppStore {
    session: SessionStoreSlice;
    fulfilmentSearchFilters: FulfilmentSearchFilters;
}

const defaultStoreValues: TaxManagerAppStore = {
    fulfilmentSearchFilters: fulfilmentSearchFiltersDefaultValues,
    session: sessionDefaultValues,
};

export const store = new Store<TaxManagerAppStore>(defaultStoreValues);
